import { render } from "./MessageTextTools.vue?vue&type=template&id=196fb409&scoped=true"
import script from "./MessageTextTools.vue?vue&type=script&lang=js"
export * from "./MessageTextTools.vue?vue&type=script&lang=js"

import "./MessageTextTools.vue?vue&type=style&index=0&id=196fb409&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196fb409"]])

export default __exports__